module.exports = __webpack_public_path__ + "img/p1.04a6f211.png";